// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"509":"dry-expansion-evap","762":"flooded-evaporator","876":"air-heat-exchanger","936":"condenser"}[chunkId] + "." + {"509":"379e9518","762":"379e9518","876":"379e9518","936":"379e9518"}[chunkId] + ".chunk.css";
};